<!-- Node -->
<div 
  class="tree-node"
  [attr.data-id]="sanitizedID"
  [ngClass]="{
    'tree-node--light': theme === treeTheme.Light,
    'tree-node--hidden': !node.boolState.shown,
    'tree-node--selected': checked,
    'tree-node--unpickable': !node.boolState.pickable && isLoft
  }">

  <!-- Expander -->
  <div 
    (click)="handleExpandClick(node, node.boolState.expanded)"
    class="tree-node__expand" 
    [class.tree-node__expand--open]="node.boolState.expanded" 
    *ngIf="nested && hasChildren(node)">

    <!-- <i class="fa fa-caret-right"></i> -->
    <fa-icon icon="caret-right"></fa-icon>
  </div>
  
  <!-- Label -->
  <div class="tree-node__label" [ngClass]="{'tree-node__label--padded': !hasChildren(node) && nested}" (click)="handleLabelClick($event, node)">
    {{ node.label }}
  </div>

  <!-- Visible -->
  <div class="tree-node__visible" (click)="toggleVisible(node)">
    <fa-icon icon="eye" size="xs" class="tree-node__eye"></fa-icon>
    <fa-icon icon="eye-slash" size="xs" class="tree-node__eye-slash"></fa-icon>
  </div>

  <!-- Actions -->
  <div class="tree-node__actions" [matMenuTriggerFor]="nodeActions">
    <fa-icon icon="ellipsis-v" size="xs"></fa-icon>
  </div>

  <!-- Main manu -->
  <mat-menu #nodeActions="matMenu" [overlapTrigger]="true">
    <button mat-menu-item [matMenuTriggerFor]="selectActions">Select</button>
    <button mat-menu-item [matMenuTriggerFor]="showHideActions">Show / Hide</button>
    <button *appFlagInternal mat-menu-item [matMenuTriggerFor]="pickableActions">Pickable / Unpickable</button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="flyToNode(node)">Fly To</button>
  </mat-menu>

  <!-- Select submenu -->
  <mat-menu #selectActions="matMenu">
    <button mat-menu-item (click)="checkNode(node, true)">Select This</button>
    <button mat-menu-item (click)="checkInverse(node)">Select Everything Else</button>
  </mat-menu>

  <!-- Show / Hide submenu -->
  <mat-menu #showHideActions="matMenu">
    <button mat-menu-item (click)="toggleVisible(node, true)" *ngIf="!node.boolState.shown">Show This</button>
    <button mat-menu-item (click)="toggleVisible(node, false)" *ngIf="node.boolState.shown">Hide This</button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="hideInverse(node)">Hide Everything Else</button>
  </mat-menu>

  <!-- Pickable submenu -->
  <mat-menu #pickableActions="matMenu">
    <button *ngIf="node.boolState.pickable" mat-menu-item (click)="togglePickable(node, false)">Make Unpickable</button>
    <button *ngIf="!node.boolState.pickable" mat-menu-item (click)="togglePickable(node, true)">Make Pickable</button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="toggleInversePickable(node, false)">Make Everything Else Unpickable</button>
  </mat-menu>

</div>